import { StateTaxExtended } from "./taxes";

export class ChangeRequestStateTax extends StateTaxExtended {
    id: number;
    jurisdictionInterationID: number;
    changeRequestStatusID: number;
    changeRequestDeniedReason: string;
    stateTaxWithholdingID: number;
    adminReviewOn: string;
    adminReviewBy: string;
    adminReviewProcess: string;

    constructor() {
        super();
        this.id = 0;
        this.jurisdictionInterationID = 0;
        this.changeRequestStatusID = 0;
        this.changeRequestDeniedReason = "";
        this.stateTaxWithholdingID = 0;
        this.adminReviewOn = "";
        this.adminReviewBy = "";
        this.adminReviewProcess = "";
    }
}


export class ChangeRequestAddressModel {
    id: number;
    memberID: number;
    address1: string;
    address2: string;
    city: string;
    state: string;
    zipCode: string;
    createdOn: string;
    createdBy: string;
    createdFromProcess: string;
    updatedOn: string;
    updatedBy: string;
    updatedFromProcess: string;
    changeRequestStatusID: number;
    changeRequestDeniedReason: string;
    memberAddressID: number;
    adminReviewOn: string;
    adminReviewBy: string;
    adminReviewProcess: string;
    errorMessage: string;
    address1Verified: string;
    address2Verified: string;
    cityVerified: string;
    countyVerified: string;
    stateVerified: string;
    zipVerified: string;
    isMissingFederalTax: boolean;
    isMissingStateTax: boolean;

    constructor() {
        this.id = 0;
        this.memberID = 0;
        this.address1 = "";
        this.address2 = "";
        this.city = "";
        this.state = "";
        this.zipCode = "";
        this.createdOn = "";
        this.createdBy = "";
        this.createdFromProcess = "";
        this.updatedOn = "";
        this.updatedBy = "";
        this.updatedFromProcess = "";
        this.changeRequestStatusID = 0;
        this.changeRequestDeniedReason = "";
        this.memberAddressID = 0;
        this.adminReviewOn = "";
        this.adminReviewBy = "";
        this.adminReviewProcess = "";
        this.errorMessage = "";
        this.address1Verified = "";
        this.address2Verified = "";
        this.cityVerified = "";
        this.countyVerified = "";
        this.zipVerified = "";
        this.isMissingFederalTax = false;
        this.isMissingStateTax = false;
    }
}

export class ChangeRequestFederalTaxModel {
    id: number;
    memberID: number;
    effectiveDate: string;
    filingStatusID: number;
    claimDependents: number;
    otherIncome: number;
    deductions: number;
    extraWithholding: number;
    medicare: boolean;
    socialSecurity: boolean;
    advanceEarnedIncomeCredit: boolean;
    federalUnemploymentTax: boolean;
    createdOn: string;
    createdBy: string;
    createdFromProcess: string;
    updatedOn: string;
    updatedBy: string;
    updatedFromProcess: string;
    twoJobIndicator: boolean;
    isFedTaxExempt: boolean;
    changeRequestStatusID: number;
    changeRequestDeniedReason: string;
    federalTaxWithholdingID: number;
    adminReviewOn: string;
    adminReviewBy: string;
    adminReviewProcess: string;

    constructor() {
        this.id = 0;
        this.memberID = 0;
        this.effectiveDate = "";
        this.filingStatusID = 0;
        this.claimDependents = null;
        this.otherIncome = null;
        this.deductions = null;
        this.extraWithholding = null;
        this.medicare = false;
        this.socialSecurity = false;
        this.advanceEarnedIncomeCredit = false;
        this.federalUnemploymentTax = false;
        this.createdOn = null;
        this.createdBy = null;
        this.createdFromProcess = null;
        this.updatedOn = null;
        this.updatedBy = null;
        this.updatedFromProcess = null;
        this.twoJobIndicator = false;
        this.isFedTaxExempt = false;
        this.changeRequestStatusID = 0;
        this.changeRequestDeniedReason = null;
        this.federalTaxWithholdingID = 0;
        this.adminReviewOn = null;
        this.adminReviewBy = null;
        this.adminReviewProcess = null;
    }
}